import React, { useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { postWithoutAuth } from '../../config/Axios';
import AuthLayout from './auth-layout';
import { isArray, isAuthenticated } from '../../helpers/functions';
import logo from '../../assets/images/logo.png';
import { Spin } from 'antd';
import PasswordInput from '../../components/PasswordInput';

const ResetPassword = () => {
    const history = useHistory();
    const { token } = useParams();
    const { userData } = useSelector((state) => state.user);

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    const getContinuePath = () => {
        if (userData?.role === 'customer') {
            return '/customer/upcoming-appointments';
        }
        if (userData?.role === 'business') {
            return '/dashboard';
        }
        return '/home';
    };

    const resetPassword = async () => {
        try {
            setErrors({});
            setIsLoading(true);
            await postWithoutAuth(`auth/reset-password`, {
                token,
                password,
                confirmPassword,
            });
            setIsLoading(false);

            if (isAuthenticated()) {
                setSuccessMessage(
                    'Password updated successfully. Your current session is still active.'
                );
                setPassword('');
                setConfirmPassword('');
                return;
            }

            history.push('/login?passwordSuccess=true');
        } catch (error) {
            setIsLoading(false);
            const updatedFieldErrors = {};
            const data = error?.response?.data;

            if (isArray(data?.message)) {
                data?.message?.forEach((fieldError) => {
                    updatedFieldErrors[fieldError.field] = fieldError.message;
                });
            } else if (data?.statusCode === 400) {
                updatedFieldErrors.confirmPassword = data.message;
            } else if (data?.statusCode === 404) {
                updatedFieldErrors.confirmPassword = data.message;
            }

            setErrors(updatedFieldErrors);
        }
    };

    return (
        <AuthLayout>
            <div className="position-relative w-100">
                <div
                    className="d-flex justify-content-center p-1 rounded mb-4 position-relative"
                    style={{ backgroundColor: '#2b5c35' }}
                >
                    <button
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            history.goBack();
                        }}
                        className="btn position-absolute start-0 top-50 translate-middle-y ms-3 p-0 d-flex align-items-center justify-content-center"
                        style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '50%',
                            backgroundColor: 'rgba(255, 255, 255, 0.18)',
                            border: 'none',
                            color: '#ffffff',
                            transition: 'all 0.2s ease',
                            zIndex: 10,
                        }}
                        title="Go Back"
                    >
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M15 19.92L8.48 13.4C7.71 12.63 7.71 11.37 8.48 10.6L15 4.08"
                                stroke="currentColor"
                                strokeWidth="2.5"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </button>
                    <Link
                        className="d-flex justify-content-center align-items-center py-1 text-decoration-none"
                        to="/home"
                    >
                        <img src={logo} alt="Logo" style={{ width: '132px' }} />
                    </Link>
                </div>
                <div className="col-12 px-0 pt-lg-0 pt-5">
                    <h5 className="color-primary poly f-36 fw-400 lh-48 m-0 text-center">
                        Reset your password
                    </h5>
                </div>

                <div className="col-12 px-0 pb-md-30 pb-3">
                    <h6 className="c-667085 poppins f-14 fw-400 lh-20 m-0 text-center">
                        please fill the information below
                    </h6>
                </div>

                {successMessage && (
                    <div className="centered-container">
                        <div className="success-badge mb-2">
                            <span>{successMessage}</span>
                        </div>
                    </div>
                )}

                {!successMessage && (
                    <>
                        <div className="col-12 px-md-0 position-relative">
                            <div className="mb-20">
                                <label
                                    htmlFor="password"
                                    className="form-label c-667085 poppins f-14 fw-400 lh-20"
                                >
                                    Password{' '}
                                    <span className="text-danger">*</span>
                                </label>
                                <PasswordInput
                                    id="password"
                                    name="password"
                                    value={password}
                                    onChange={(e) =>
                                        setPassword(e.target.value)
                                    }
                                    placeholder="New Password"
                                />

                                {errors.password && (
                                    <p className="password-error-text">
                                        {errors.password}
                                    </p>
                                )}
                            </div>
                        </div>

                        <div className="col-12 px-md-0 position-relative">
                            <div className="mb-20">
                                <label
                                    htmlFor="confirmPassword"
                                    className="form-label c-667085 poppins f-14 fw-400 lh-20"
                                >
                                    Confirm Password{' '}
                                    <span className="text-danger">*</span>
                                </label>
                                <PasswordInput
                                    id="confirmPassword"
                                    name="confirmPassword"
                                    value={confirmPassword}
                                    onChange={(e) =>
                                        setConfirmPassword(e.target.value)
                                    }
                                    placeholder="Confirm Password"
                                />

                                {errors.confirmPassword && (
                                    <p className="password-error-text">
                                        {errors.confirmPassword}
                                    </p>
                                )}
                            </div>
                        </div>

                        <div className="col-12 px-md-0">
                            <button
                                className="btn btn-create-acc mb-20"
                                onClick={resetPassword}
                                disabled={isLoading}
                            >
                                {isLoading ? <Spin /> : 'Reset Password'}
                            </button>
                        </div>
                    </>
                )}

                {successMessage && (
                    <div className="col-12 px-md-0">
                        {isAuthenticated() ? (
                            <Link
                                to={getContinuePath()}
                                className="btn btn-create-acc mb-20 d-block text-center text-decoration-none"
                            >
                                Continue to your account
                            </Link>
                        ) : (
                            <Link
                                to="/login?passwordSuccess=true"
                                className="btn btn-create-acc mb-20 d-block text-center text-decoration-none"
                            >
                                Go to login
                            </Link>
                        )}
                    </div>
                )}
            </div>
        </AuthLayout>
    );
};

export default ResetPassword;
